const awardSliderInit = () => {
    if (typeof Swiper === "undefined") {
        return;
    }
    const awardSlider = document.querySelectorAll('.gg-awards-carousel');
    const slidesPerViewDesktop = 4;
    const slidesPerViewTablet = 3;
    const slidesPerViewMobile = 1;
    let view = slidesPerViewDesktop;

    const awardSliderFocusSet = (swiper) => {
        if (document.body.clientWidth >= 1025) {
            view = slidesPerViewDesktop;
        } else if (document.body.clientWidth < 1025 && document.body.clientWidth >= 600) {
            view = slidesPerViewTablet;
        } else {
            view = slidesPerViewMobile;
        }

        swiper.slides.forEach((slide) => {
            const itemLink = slide.querySelector('.wp-block-button__link');
            if (itemLink) {
                itemLink.setAttribute('tabindex', '-1');
            }
        });

        for (let i = 0; i < view; i++) {
            if (swiper.slides[swiper.realIndex + i]) {
                const itemLinkI = swiper.slides[swiper.realIndex + i].querySelector('.wp-block-button__link');
                if (itemLinkI) {
                    itemLinkI.removeAttribute('tabindex');
                }
            }
        }
    };

    document.addEventListener('click', (e) => {
        const eTarget = e.target;
        const itemSlide = eTarget.closest('.gg-awards-carousel__box');
        if (itemSlide) {
            const url = itemSlide.getAttribute('data-href');
            window.open(url, '_self');
        }
    });

    awardSlider.forEach((module) => {
        const swiperElement = module.querySelector('.swiper');
        if (swiperElement) {
            // eslint-disable-next-line no-undef
            new Swiper(swiperElement, {
                spaceBetween: 0,
                navigation: {
                    nextEl: module.querySelector('.swiper-button-next '),
                    prevEl: module.querySelector('.swiper-button-prev'),
                },
                watchOverflow: true,
                breakpoints: {
                    1025: {
                        slidesPerView: slidesPerViewDesktop,
                    },
                    600: {
                        slidesPerView: slidesPerViewTablet,
                    },
                    0: {
                        slidesPerView: slidesPerViewMobile,
                    },
                },
                on: {
                    init: (swiper) => {
                        awardSliderFocusSet(swiper);
                    },
                    slideChange: (swiper) => {
                        awardSliderFocusSet(swiper);
                    },
                    breakpoint: (swiper) => {
                        awardSliderFocusSet(swiper);
                    },
                },
            });
        }
    });
};
awardSliderInit();

if (window.acf) {
    window.acf.addAction('render_block_preview/type=awards-carousel', awardSliderInit);
}
